{
  const toggle = document.querySelector('.bp-gg-header__mobile-toggle');
  const tabletNav = document.getElementById('bp-gg-tablet-nav');
  const mobileNav = document.getElementById('bp-gg-mobile-nav');

  const mqTablet = window.matchMedia('(min-width: 600px) and (max-width: 1125px)');
  const mqDesktop = window.matchMedia('(min-width: 1126px)');

  function getActiveNav() {
    return mqTablet.matches ? tabletNav : mobileNav;
  }

  function closeAll(returnFocus) {
    const focusWasInNav =
      tabletNav?.contains(document.activeElement) ||
      mobileNav?.contains(document.activeElement);
    if (tabletNav) tabletNav.hidden = true;
    if (mobileNav) mobileNav.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if ((returnFocus || focusWasInNav) && toggle) toggle.focus();
  }

  if (toggle) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      if (open) {
        closeAll(false);
      } else {
        const activeNav = getActiveNav();
        if (activeNav) {
          activeNav.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
          toggle.setAttribute('aria-controls', activeNav.id);
        }
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        closeAll(true);
      }
    });

    mqDesktop.addEventListener('change', (e) => {
      if (e.matches) closeAll(false);
    });

    mqTablet.addEventListener('change', () => {
      closeAll(false);
    });
  }
}
